import { cn } from "@/common/helpers/utils";
import { Card } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { BaseScheme } from "@/store/user-config-store";
import { useTranslation } from "react-i18next";
import type { BaseSchemeDefinition } from "../_constants/themes";

interface BaseSchemePickerProps {
  label: string;
  schemes: BaseSchemeDefinition[];
  selectedScheme: BaseScheme;
  onSelect: (scheme: BaseScheme) => void;
}

export function BaseSchemePicker({ label, schemes, selectedScheme, onSelect }: BaseSchemePickerProps) {
  const { t } = useTranslation("user-settings");

  return (
    <div className="space-y-3">
      <Label className="text-sm font-medium">{label}</Label>
      <div className="grid grid-cols-[repeat(auto-fit,minmax(100px,1fr))] gap-3">
        {schemes.map((item) => (
          <Card
            key={item.scheme}
            depth={1}
            className={cn(
              "items-center gap-1.5 p-3 transition-all",
              selectedScheme === item.scheme
                ? "border-primary/30 bg-primary/10 dark:border-primary/30 dark:bg-primary/10"
                : "hover:bg-primary/20 hover:border-primary/60 hover:dark:bg-primary/20 hover:dark:border-primary/60 cursor-pointer",
            )}
            onClick={() => onSelect(item.scheme)}
            role="button"
            tabIndex={0}
            aria-pressed={selectedScheme === item.scheme}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") onSelect(item.scheme);
            }}
          >
            <div className="h-6 w-6 rounded-full border" style={{ backgroundColor: item.backgroundColor }} />
            <span className="text-xs font-medium">{t(item.labelKey)}</span>
          </Card>
        ))}
      </div>
    </div>
  );
}
